export const Links = {
  Telegram: 'https://t.me/wazzupjohnny',
  GitHub: 'https://github.com/eugenepokalyuk',
  Npm: 'https://www.npmjs.com/~wazzupjohnny',
  TelegramChannel: 'https://t.me/wazzupjohnny_channel',
};
